export default __webpack_public_path__ + "static/media/verify.5f6ad260.svg";